import "./index.less";
import { Tag } from "antd";
import React from "react";
import { get, yxStyleProps } from "../../../../utils";
import { YxComponent, Connection } from "../../../YxComponent";

/**
 * @param selectable 表示tag是否可以选中
 * @param id 组件的id
 * @param {Function} onSelected
 * @param {Function} change
 * @param 继承antd Tag 参数
 * @returns
 */
const defaultProps = function () {
  return {
    styleParam: {
      type: "default",
      size: "default",
    },
    id: null,
    disabled: false,
    selectable: false,
    selected: undefined,
  };
};

@Connection(defaultProps)
class YxTag extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      disabled: false,
      selected: false,
    };
    this.baseClassName = "yx_operation_tag_base";
  }

  /**
   * 受控
   *
   * @memberof YxTag
   */
  controlTagSelected = (propsSelected) => {
    const selected = !propsSelected;
    const id = get(this.props, "id", null);
    get(this.props, "onSelected", () => {})(selected, id);
  };

  /**
   * 非受控
   *
   * @memberof YxTag
   */
  noControlTagSelected = () => {
    this.setState({ selected: !this.state.selected }, () => {
      const { selected } = this.state;
      const id = get(this.props, "id", null);
      get(this.props, "onSelected", () => {})(selected, id);
      get(this.props, "change", () => {})(selected, id);
    });
  };

  onSelected = () => {
    const propsSelected = get(this.props, "selected", null);
    if (propsSelected != null) {
      this.controlTagSelected(propsSelected);
    } else {
      this.noControlTagSelected();
    }
  };

  get disabled() {
    const statusList = [
      get(this.props, ["disabled", "loading"], true),
      get(this.state, ["disabled", "loading"], true),
    ];
    return statusList.some((item) => item === true);
  }

  get className() {
    const classDict = {
      yx_yxTag_: "styleParam.type",
      yx_yxTag_size_: "styleParam.size",
    };
    const result = this.styleParamClassName(this.props, classDict);
    return result;
  }

  /**
   * 判断当前tag选中状态
   *
   * @readonly
   * @memberof YxTag
   */
  get selected() {
    const propsSelected = get(this.props, "selected", null);
    const selectable = get(this.props, "selectable", false);
    if (selectable === true) {
      if (propsSelected != null) {
        return propsSelected;
      }
      return this.state.selected;
    }
    return false;
  }

  get param() {
    const result = {
      ...this.props,
      disabled: this.disabled,
      className: this.className,
      isSelected: this.selected === true ? "selected" : "",
    };
    if (get(this.props, "selectable", true) === true) {
      result.onClick = this.onSelected;
    }
    return result;
  }

  render() {
    return (
      <Tag
        {...yxStyleProps(
          this.param,
          "change",
          "onSelected",
          "isSelected",
          "selectable",
          "loading"
        )}
      ></Tag>
    );
  }
}

export default YxTag;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/components/YxTag/index.js